// extracted by mini-css-extract-plugin
module.exports = {"overlay":"VideoInfo-module__overlay___22RJH","length":"VideoInfo-module__length___3lQ8S"};